import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        modalContainer: css`
            width: auto;
        `,
        modalBody: css`
            width: auto;
            max-width: initial;
            max-height: initial !important;
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 0;
            &:after {
                display: none;
            }
        `,
        modalContent: css`
            text-align: center;
            padding: 22px;
        `,
    },
};
primaryImageStyles.fullPrimaryImage = {
    image: {
        css: css`
            cursor: auto;
            img {
                width: auto;
                max-height: 70vh;
            }
        `,
    },
    img: {
        css: css`
            cursor: auto;
            width: auto;
            max-height: 70vh;
        `,
    },
};

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            min-height: 204px;
            margin: 0;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            cursor: pointer;
            img {
                height: auto;
                max-width: 100%;
            }
        `,
    },
    image: {
        css: css`
            margin: auto;
            cursor: pointer;
        `,
    },
    img: {
        css: css`
            cursor: pointer;
        `,
    },
    container: {
        css: css`
            position: relative;
            margin-bottom: 12px;
        `,
    },
} as any;
